import { writable } from 'svelte/store';
export const idPageHome = "home";
export const idPagePodcast = "podcast";
export const idPagePodcastsCategory = "category";
export const idPagePodcastCategories = "podcasts";
export const idPageAPropos = "apropos";
export const namePageHome = "";
export const namePagePodcast = "Podcast";
export const namePagePodcastsCategory = "Podcasts de la categorie";
export const namePagePodcastCategories = "Podcasts";
export const namePageAPropos = "Présentation";
export const storeFirstDisplayHome = writable(true);
